import { Link } from "react-router-dom";
import styles from "./NotFoundPage.module.css";

export function NotFoundPage() {
  return (
    <main className={styles.container}>
      <h1 className={styles.code}>404</h1>
      <p className={styles.message}>ページが見つかりません</p>
      <Link to="/" className={styles.homeLink}>
        ホームへ
      </Link>
    </main>
  );
}
